"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Koliko traje prosječan popravak romobila?",
  answer: "Većinu standardnih kvarova i dijagnostiku rješavamo u roku od 24 do 48 sati. U slučaju kompleksnijih zahvata na elektronici ili čekanja specifičnih rezervnih dijelova, rok se može produljiti, o čemu ćete biti odmah obaviješteni."
}, {
  question: "Nudite li jamstvo na obavljeni servis?",
  answer: "Apsolutno. Na sve naše servisne usluge i ugrađene originalne ili premium dijelove dajemo garanciju od 6 mjeseci. Vaša sigurnost i povjerenje su nam na prvom mjestu."
}, {
  question: "Nisam iz Zagreba, kako vam mogu dostaviti romobil?",
  answer: "Surađujemo s vodećim dostavnim službama. Svoj romobil možete sigurno zapakirati i poslati na našu adresu u Zagrebu. Nakon servisa, romobil testiramo, dodatno zaštićujemo i šaljemo natrag na vaša vrata."
}, {
  question: "Što uključuje servis i obnova baterije?",
  answer: "Naš specijalizirani servis baterija uključuje detaljnu BMS dijagnostiku, provjeru zdravlja ćelija, zamjenu neispravnih ćelija ili kompletnu izradu novog baterijskog paketa s premium ćelijama za maksimalan domet."
}, {
  question: "Mogu li samostalno kupiti dijelove u vašoj trgovini?",
  answer: "Naravno! ChargeZone webshop nudi širok asortiman guma, kočnica, elektronike i dodatne opreme. Sve narudžbe šaljemo isti ili sljedeći radni dan kako biste što prije bili spremni za vožnju."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="224347" id="česta-pitanja" className="bg-background text-foreground py-20 px-4 md:py-32">
      <div className="mx-auto max-w-[800px]">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-primary">
            Česta pitanja
          </h2>
          <p className="font-sans text-muted-foreground text-lg max-w-2xl mx-auto">
            Pronađite odgovore na najčešća pitanja o servisu, jamstvu i kupnji dijelova za vaš električni romobil.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full flex flex-col gap-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border/60 rounded-sm px-2 md:px-6 data-[state=open]:bg-accent/5 transition-colors duration-300 shadow-sm">
              <AccordionTrigger className="hover:no-underline py-6 text-left font-default text-base md:text-lg font-bold leading-snug text-primary hover:text-ring transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}